import React, { SetStateAction, useContext, useEffect } from "react";
import { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import { Paper, Stack, TableBody } from "@mui/material";
import { TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import {
  StyledTableHead,
  StyledTableCell,
} from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import { CustomTextField } from "../../../Styles/theme/customThemeprovider";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { IAnaliseAguaA1 } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { Alert } from "../../../Components/Alert/Alert";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { ICabecalho } from "../../../Interfaces/anexos/anexo1/analise_e_foliar1_1_3";
import { IPlanoNutrientes } from "../../../Interfaces/anexos/anexo1/plano_nutrientes1_3";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { format_strings_to_numbers } from "../../../Componentes_modulo/formulas_genericas/formulas_genericas";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";
import { useLocation } from "react-router-dom";

interface AnaliseAguaForm_prop {
  obj_anexo_cabecalho_selecionado: ICabecalho | undefined;
  set_obj_da_tabela_3_atualizado: React.Dispatch<SetStateAction<IPlanoNutrientes | undefined>>;
}

export const AnaliseAguaForm: React.FC<AnaliseAguaForm_prop> = ({ obj_anexo_cabecalho_selecionado, set_obj_da_tabela_3_atualizado }) => {
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const auth = useContext(AuthContext);
  const [flag_editar, set_flag_editar] = useState(true);
  const [createTable, setCreateTable] = useState(false);
  const [message, setMessage] = useState("");
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [error_dotacao, set_error_dotacao] = React.useState(false);
  const [error_resultado_camp1, set_error_resultado_camp1] = React.useState(false);
  const [error_resultado_camp2, set_error_resultado_camp2] = React.useState(false);
  const [error_resultado_camp3, set_error_resultado_camp3] = React.useState(false);
  const [error_resultado_camp4, set_error_resultado_camp4] = React.useState(false);
  const [error_resultado_camp5, set_error_resultado_camp5] = React.useState(false);
  const [error_resultado_camp6, set_error_resultado_camp6] = React.useState(false);
  const [error_resultado_camp7, set_error_resultado_camp7] = React.useState(false);
  const [error_resultado_camp8, set_error_resultado_camp8] = React.useState(false);
  const [error_resultado_camp9, set_error_resultado_camp9] = React.useState(false);
  const [error_resultado_camp10, set_error_resultado_camp10] = React.useState(false);
  const [error_resultado_camp11, set_error_resultado_camp11] = React.useState(false);
  const [error_quantidade_nutri_camp1, set_error_quantidade_nutri_camp1] = React.useState(false);
  const [error_quantidade_nutri_camp2, set_error_quantidade_nutri_camp2] = React.useState(false);
  const [error_data_resultados, set_error_data_resultados] = useState(false)
  const [error_n_amostras, set_error_n_amostras] = useState(false)
  const [error_data_colheira, set_error_data_colheira] = useState(false)
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [obj_anexo, set_obj_anexo] = useState<IAnaliseAguaA1>();
  const [obj_anexo_lista, set_obj_anexo_lista] = useState<IAnaliseAguaA1[]>([]);
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };

  const handle_delete_anexo = async () => {
    try {
      setIsLoading(true);

      let res = await del(auth.token.cookie_token,
        `delete__reg_anexo_um_dois/${obj_anexo?.id_anexo_um_dois}`
      );
      if (res.status === 200) {
        let lista_aux: any = obj_anexo_lista.filter((el) => {
          if (el.id_anexo_um_dois !== obj_anexo?.id_anexo_um_dois) {
            return el
          }
        })
        set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
        if (lista_aux === undefined || lista_aux.length === 0) {
          setCreateTable(true)
        }
        set_obj_anexo(undefined)
        set_obj_da_tabela_3_atualizado(res.data.result)

        setMessage("Registo eliminado com sucesso!");
        set_open_dialog_tem_a_certeza_que_quer_eliminar(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handle_delete_anexo", error, true);
      setIsLoading(false);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
    }
  };

  const handle_criar_anexo = async () => {
    if (!obj_anexo?.data_colheita || obj_anexo?.data_colheita === "" || !obj_anexo?.data_resultados || obj_anexo?.data_resultados === "" || error_dotacao || error_resultado_camp1 || error_resultado_camp2 || error_resultado_camp3 || error_resultado_camp4 || error_resultado_camp5 || error_resultado_camp6 || error_resultado_camp7 || error_resultado_camp8 || error_resultado_camp9 || error_resultado_camp10 || error_resultado_camp11 || error_quantidade_nutri_camp1 || error_quantidade_nutri_camp2 || error_n_amostras) {
      if (!obj_anexo?.data_colheita || obj_anexo?.data_colheita === "") {
        set_error_data_colheira(true)
      }
      if (!obj_anexo?.data_resultados || obj_anexo?.data_resultados === "") {
        set_error_data_resultados(true)
      }

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {

      try {
        setIsLoading(true);

        let data = await post(auth.token.cookie_token, "new_reg_anexo_um_dois", {
          payload: {

            id_anexo_um_dois: 0,
            dotacao: obj_anexo?.dotacao === undefined ? 0 : obj_anexo?.dotacao,
            origem_agua: obj_anexo?.origem_agua === undefined ? '' : obj_anexo?.origem_agua,
            metodo_rega: obj_anexo?.metodo_rega === undefined ? '' : obj_anexo?.metodo_rega,
            eficiencia: obj_anexo?.eficiencia === undefined ? '' : obj_anexo?.eficiencia,
            razao: obj_anexo?.razao === undefined ? '' : obj_anexo?.razao,
            resultado_camp1: obj_anexo?.resultado_camp1 === undefined ? '' : obj_anexo?.resultado_camp1,
            resultado_camp2: obj_anexo?.resultado_camp2 === undefined ? '' : obj_anexo?.resultado_camp2,
            resultado_camp3: obj_anexo?.resultado_camp3 === undefined ? '' : obj_anexo?.resultado_camp3,
            resultado_camp4: obj_anexo?.resultado_camp4 === undefined ? '' : obj_anexo?.resultado_camp4,
            resultado_camp5: obj_anexo?.resultado_camp5 === undefined ? '' : obj_anexo?.resultado_camp5,
            resultado_camp6: obj_anexo?.resultado_camp6 === undefined ? '' : obj_anexo?.resultado_camp6,
            resultado_camp7: obj_anexo?.resultado_camp7 === undefined ? '' : obj_anexo?.resultado_camp7,
            resultado_camp8: obj_anexo?.resultado_camp8 === undefined ? '' : obj_anexo?.resultado_camp8,
            resultado_camp9: obj_anexo?.resultado_camp9 === undefined ? '' : obj_anexo?.resultado_camp9,
            resultado_camp10: obj_anexo?.resultado_camp10 === undefined ? '' : obj_anexo?.resultado_camp10,
            resultado_camp11: obj_anexo?.resultado_camp11 === undefined ? '' : obj_anexo?.resultado_camp11,
            quantidade_nutri_camp1: obj_anexo?.quantidade_nutri_camp1 === undefined ? '' : obj_anexo?.quantidade_nutri_camp1,
            quantidade_nutri_camp2: obj_anexo?.quantidade_nutri_camp2 === undefined ? '' : obj_anexo?.quantidade_nutri_camp2,
            quantidade_nutri_camp3: obj_anexo?.quantidade_nutri_camp3 === undefined ? '' : obj_anexo?.quantidade_nutri_camp3,
            k: obj_anexo?.k === undefined ? false : obj_anexo?.k,
            ko: obj_anexo?.ko === undefined ? false : obj_anexo?.ko,
            data_colheita: obj_anexo?.data_colheita === undefined ? '' : obj_anexo?.data_colheita,
            data_resultados: obj_anexo?.data_resultados === undefined ? '' : obj_anexo?.data_resultados,
            n_amostras: obj_anexo?.n_amostras === undefined ? 0 : obj_anexo?.n_amostras,
            n_boletin: obj_anexo?.n_boletin === undefined ? '' : obj_anexo?.n_boletin,

            id_anexo_um_cabecalho: obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: ""
          }
        })
        if (data.status === 200) {
          setMessage("Operação efetuada com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editado(false)

          setCreateTable(false)
          set_flag_editar(false)
          set_obj_anexo(undefined)
          set_obj_anexo_lista((old) => [...old, data.data.result[0]])
          set_obj_da_tabela_3_atualizado(data.data.result[1])

        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }
        setIsLoading(false);

      } catch (error) {
        func_print('handle_criar_anexo', error, true)
        setIsLoading(false);

        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
    }
  }
  const handleCloseDialog = () => {
    set_obj_anexo(undefined)
    set_flag_editar(false)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };

  const onInputChange = (event: any) => {
    const { name, value, type, checked } = event.target;
    set_flag_editado(true)

    if (type === "checkbox") {
      set_obj_anexo((prev: any) => {
        return {
          ...prev,
          [name]: checked,
        };
      });
    } else {
      if (name === "data_colheita") {
        if (value.trim() === "" || value === undefined) {
          set_error_data_colheira(true);
        } else {
          set_error_data_colheira(false);
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: value,
        }));
      } else if (name === "data_resultados") {
        if (value.trim() === "" || value === undefined) {
          set_error_data_resultados(true);
        } else {
          set_error_data_resultados(false);
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: value,
        }));
      } else if (name === 'n_amostras') {
        if (!/^\d+$/.test(value)) {
          set_error_n_amostras(true)
        } else {
          set_error_n_amostras(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: value,
        }));
      } else if (name === 'dotacao') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_dotacao(true)
        } else {
          set_error_dotacao(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp1') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp1(true)
        } else {
          set_error_resultado_camp1(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp2') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp2(true)
        } else {
          set_error_resultado_camp2(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp3') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp3(true)
        } else {
          set_error_resultado_camp3(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp4') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp4(true)
        } else {
          set_error_resultado_camp4(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp5') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp5(true)
        } else {
          set_error_resultado_camp5(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp6') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp6(true)
        } else {
          set_error_resultado_camp6(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp7') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp7(true)
        } else {
          set_error_resultado_camp7(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp8') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp8(true)
        } else {
          set_error_resultado_camp8(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp9') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp9(true)
        } else {
          set_error_resultado_camp9(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp10') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp10(true)
        } else {
          set_error_resultado_camp10(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'resultado_camp11') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_resultado_camp11(true)
        } else {
          set_error_resultado_camp11(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'quantidade_nutri_camp1') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_quantidade_nutri_camp1(true)
        } else {
          set_error_quantidade_nutri_camp1(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else if (name === 'quantidade_nutri_camp2') {
        if (/[a-zA-Z]/.test(value)) {
          set_error_quantidade_nutri_camp2(true)
        } else {
          set_error_quantidade_nutri_camp2(false)
        }
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: format_strings_to_numbers(value, false),
        }));
      } else {
        set_obj_anexo((old: any) => ({
          ...old,
          [name]: value,
        }));

      }

    }
  };

  const get_info = async () => {
    try {
      let res = await get(auth.token.cookie_token,
        `/get_reg_anexo_um_dois_cabecalho/${obj_anexo_cabecalho_selecionado?.id_anexo_um_cabecalho}`
      );
      if (res.status === 200) {
        if (res.data.result.length !== 0) {
          set_obj_anexo_lista(res.data.result);
        } else {
          setCreateTable(true)
          set_flag_editar(false)
        }
      } else {
        setMessage("Erro a carregar informação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      if (obj_anexo_cabecalho_selecionado !== undefined) {
        await get_info();
        set_flag_editar(false)
      } else {
        setCreateTable(false)
        set_obj_anexo_lista([])
        set_flag_editar(true)
      }
    })();
  }, [obj_anexo_cabecalho_selecionado]);

  const handle_update_anexo = async () => {
    if (!obj_anexo?.data_colheita || obj_anexo?.data_colheita === "" || !obj_anexo?.data_resultados || obj_anexo?.data_resultados === "" || error_dotacao || error_resultado_camp1 || error_resultado_camp2 || error_resultado_camp3 || error_resultado_camp4 || error_resultado_camp5 || error_resultado_camp6 || error_resultado_camp7 || error_resultado_camp8 || error_resultado_camp9 || error_resultado_camp10 || error_resultado_camp11 || error_quantidade_nutri_camp1 || error_quantidade_nutri_camp2 || error_n_amostras) {
      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    } else {
      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, "update_reg_anexo_um_dois", { payload: obj_anexo });

        if (res.status === 200) {
          let lista_aux: any = obj_anexo_lista.map((el) => {
            if (el.id_anexo_um_dois !== obj_anexo?.id_anexo_um_dois) {
              return el
            } else {
              return res.data.result[0]
            }
          })
          set_obj_anexo_lista(lista_aux === undefined ? [] : lista_aux)
          set_obj_anexo(undefined);
          set_obj_da_tabela_3_atualizado(res.data.result[1])
          set_flag_editar(false)
          setMessage("Gravado com sucesso!");
          setOpenSnackSuccess(true);
          set_flag_editado(false)

        } else {
          setMessage("Erro ao gravar!");

          setOpenSnackError(true);
        }

        setIsLoading(false);
      } catch (error) {
        func_print("handle_update_anexo", error, true);
        setMessage("Erro ao gravar!");

        setOpenSnackError(true);
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          height: "auto",
          width: "auto",
          margin: 2,
          padding: 2,
        }}
      >
        <Snackbar
          open={openSnackSuccess}
          autoHideDuration={2000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSnackError}
          autoHideDuration={2000}
          onClose={handleCloseSnack}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="error"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <table style={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={12}
                sx={{
                  fontWeight: 600,

                  fontFamily: "candara",
                  fontSize: 16,
                }}
              >
                1.2 Análise da água de rega
                <BasicPopover
                  text={
                    "Os boletins de análise devem ser mantidos pelo beneficiário por forma a serem consultados sempre que necessário pelas entidades que monitorizam, verificam a aplicação da legislação nacional aplicável no âmbito da gestão de nutrientes disponibilizados às culturas."
                  }
                />
              </TableCell>

              {createTable === true ?
                <TableCell >
                  <Stack direction="row" justifyContent="end">
                    {is_historico === true ? <></> :

                      <ButtonCadernos
                        mostrarBotaoGravar
                        aoClicarGravar={() => { handle_criar_anexo() }}

                      />}
                  </Stack>
                </TableCell>
                :
                <></>

              }
            </TableRow>
          </TableHead>
          <TableBody>
            {createTable && (
              <>
                <TableRow>
                  <TableCell
                    colSpan={5}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    Dotação (m3/ha):
                    <CustomTextField
                      name="dotacao"
                      value={obj_anexo?.dotacao === undefined ? '' : obj_anexo?.dotacao.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_dotacao}
                      helperText={error_dotacao ? "Apenas números são aceites" : ""}
                    />
                  </TableCell>
                  <TableCell
                    colSpan={4}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Origem da água:
                      <CustomTextField
                        name="origem_agua"
                        value={obj_anexo?.origem_agua === undefined ? '' : obj_anexo?.origem_agua}
                        onChange={onInputChange}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell
                    colSpan={4}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Método de rega:
                      <CustomTextField
                        name="metodo_rega"
                        value={obj_anexo?.metodo_rega === undefined ? '' : obj_anexo?.metodo_rega}
                        onChange={onInputChange}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={4}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Eficiência de rega:
                      <CustomTextField
                        name="eficiencia"
                        value={obj_anexo?.eficiencia === undefined ? '' : obj_anexo?.eficiencia}
                        onChange={onInputChange}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell
                    colSpan={9}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Razão de adsorção de sódio ajustada:
                      <CustomTextField
                        name="razao"
                        multiline
                        value={obj_anexo?.razao === undefined ? '' : obj_anexo?.razao}

                        onChange={onInputChange}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <StyledTableHead sx={{ minWidth: 100 }} colSpan={2}>
                    Elemento/nutriente
                    <BasicPopover text="Todos os campos deste quadro são de preenchimento obrigatório." />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    N
                    <BasicPopover text="Azoto sob a forma de nitrato (NO3)" />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    P2O5
                    <BasicPopover text="Fósforo" />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    K
                    <BasicPopover text="Potássio" />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    Mg
                    <BasicPopover text="Magnésio" />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    Bicarbonatos
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    B
                    <BasicPopover text="Boro" />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    Ca
                    <BasicPopover text="Cálcio" />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    Clorestos
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    Na
                    <BasicPopover text="Sódio" />
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    pH(H2O)
                  </StyledTableHead>
                  <StyledTableHead sx={{ minWidth: 100 }}>
                    C.E. (dS/m)
                    <BasicPopover text="Condutividade elétrica" />
                  </StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableHead>Resultado das análises</StyledTableHead>
                  <StyledTableHead>(mg/l)</StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp1"
                      value={obj_anexo?.resultado_camp1 === undefined ? '' : obj_anexo?.resultado_camp1.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp1}
                      helperText={error_resultado_camp1 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp2"
                      value={obj_anexo?.resultado_camp2 === undefined ? '' : obj_anexo?.resultado_camp2.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp2}
                      helperText={error_resultado_camp2 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp3"
                      value={obj_anexo?.resultado_camp3 === undefined ? '' : obj_anexo?.resultado_camp3.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp3}
                      helperText={error_resultado_camp3 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp4"
                      value={obj_anexo?.resultado_camp4 === undefined ? '' : obj_anexo?.resultado_camp4.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp4}
                      helperText={error_resultado_camp4 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp5"
                      value={obj_anexo?.resultado_camp5 === undefined ? '' : obj_anexo?.resultado_camp5.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp5}
                      helperText={error_resultado_camp5 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp6"
                      value={obj_anexo?.resultado_camp6 === undefined ? '' : obj_anexo?.resultado_camp6.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp6}
                      helperText={error_resultado_camp6 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp7"
                      value={obj_anexo?.resultado_camp7 === undefined ? '' : obj_anexo?.resultado_camp7.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp7}
                      helperText={error_resultado_camp7 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp8"
                      value={obj_anexo?.resultado_camp8 === undefined ? '' : obj_anexo?.resultado_camp8.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp8}
                      helperText={error_resultado_camp8 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp9"
                      value={obj_anexo?.resultado_camp9 === undefined ? '' : obj_anexo?.resultado_camp9.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp9}
                      helperText={error_resultado_camp9 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp10"
                      value={obj_anexo?.resultado_camp10 === undefined ? '' : obj_anexo?.resultado_camp10.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp10}
                      helperText={error_resultado_camp10 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                  <StyledTableHead>
                    <CustomTextField
                      name="resultado_camp11"
                      value={obj_anexo?.resultado_camp11 === undefined ? '' : obj_anexo?.resultado_camp11.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_resultado_camp11}
                      helperText={error_resultado_camp11 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableHead>
                </TableRow>
                <TableRow>
                  <StyledTableHead colSpan={2}>
                    Quantidade de nutriente fornecida pela água de rega (kg/ha)
                  </StyledTableHead>
                  <StyledTableCell>
                    <CustomTextField
                      name="quantidade_nutri_camp1"
                      value={obj_anexo?.quantidade_nutri_camp1 === undefined ? '' : obj_anexo?.quantidade_nutri_camp1.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_quantidade_nutri_camp1}
                      helperText={error_quantidade_nutri_camp1 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <CustomTextField
                      name="quantidade_nutri_camp2"
                      value={obj_anexo?.quantidade_nutri_camp2 === undefined ? '' : obj_anexo?.quantidade_nutri_camp2.toString().replace('.', ',')}
                      onChange={onInputChange}
                      error={error_quantidade_nutri_camp2}
                      helperText={error_quantidade_nutri_camp2 ? "Apenas números são aceites" : ""}
                    />
                  </StyledTableCell>

                  <StyledTableCell
                    colSpan={9}
                    sx={{ backgroundColor: "lightgray" }}
                  ></StyledTableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={5}>
                    Identificar se a avaliação do teor de potássio na água de
                    rega foi expresso em:
                  </TableCell>

                  <TableCell colSpan={4}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <FormControlLabel
                        name="k"
                        label={
                          <Typography fontFamily="candara" fontSize={18}>
                            K
                          </Typography>
                        }
                        aria-readonly
                        control={
                          <Checkbox
                            checked={!!obj_anexo?.k}
                            onChange={onInputChange}
                            name="k"
                            disabled={!!flag_editar}
                            sx={{
                              color: "#aaaaaa",
                              "&.Mui-checked": {
                                color: "#C94F1E",
                              },
                            }}
                          />
                        }
                      />
                    </Stack>
                  </TableCell>

                  <TableCell colSpan={4}>
                    <FormControlLabel
                      name="ko"
                      label={
                        <Typography fontFamily="candara" fontSize={18}>
                          K2O
                        </Typography>
                      }
                      aria-readonly
                      control={
                        <Checkbox
                          checked={!!obj_anexo?.ko}
                          onChange={onInputChange}
                          name="ko"
                          disabled={!!flag_editar}
                          sx={{
                            color: "#aaaaaa",
                            "&.Mui-checked": {
                              color: "#C94F1E",
                            },
                          }}
                        />
                      }
                    />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    colSpan={4}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Data da colheita da água:
                      <TextField
                        variant="filled"
                        name="data_colheita"
                        error={error_data_colheira}
                        helperText={error_data_colheira === true ? "Preencha este campo" : ''}
                        type="date"

                        value={obj_anexo?.data_colheita === undefined ? '' : obj_anexo?.data_colheita}
                        onChange={onInputChange}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell
                    colSpan={3}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Data emissão resultados:
                      <TextField
                        variant="filled"
                        name="data_resultados"
                        error={error_data_resultados}
                        helperText={error_data_resultados === true ? "Preencha este campo" : ''}
                        type="date"

                        value={obj_anexo?.data_resultados === undefined ? '' : obj_anexo?.data_resultados}
                        onChange={onInputChange}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell
                    colSpan={3}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Nº de amostras:
                      <CustomTextField
                        name="n_amostras"
                        value={obj_anexo?.n_amostras === undefined ? '' : obj_anexo?.n_amostras}
                        onChange={onInputChange}
                        error={error_n_amostras}
                        helperText={error_n_amostras ? 'Apenas números são aceites' : ""}
                      />
                    </Stack>
                  </TableCell>
                  <TableCell
                    colSpan={3}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "candara",
                    }}
                  >
                    <Stack
                      direction="row"
                      sx={{ justifyContent: "center", alignItems: "center" }}
                    >
                      Nº do Boletim:
                      <CustomTextField
                        name="n_boletin"
                        value={obj_anexo?.n_boletin === undefined ? '' : obj_anexo?.n_boletin}
                        onChange={onInputChange}
                      />
                    </Stack>
                  </TableCell>
                </TableRow>
              </>
            )}

            {obj_anexo_lista.map((row, key) => {
              if (obj_anexo?.id_anexo_um_dois === row.id_anexo_um_dois) {
                return (
                  <>
                    <TableRow key={key} >
                      <TableCell colSpan={13}>
                        <Stack direction='row' sx={{ justifyContent: 'right' }}>
                          <ButtonCadernos
                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_update_anexo() }}
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              if (flag_editado) {
                                set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                              } else {

                                set_obj_anexo(undefined)
                                set_flag_editar(false)
                              }

                            }}
                          />
                        </Stack>
                      </TableCell>

                    </TableRow>


                    <TableRow>
                      <TableCell
                        colSpan={5}
                        sx={{
                          fontWeight: 600,

                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{ justifyContent: "center" }}
                        >
                          Dotação (m3/ha):
                          <CustomTextField
                            name="dotacao"
                            value={obj_anexo?.dotacao === undefined ? '' : obj_anexo?.dotacao}
                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                      <TableCell
                        colSpan={4}
                        sx={{
                          fontWeight: 600,

                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{ justifyContent: "center" }}
                        >
                          Origem da água:
                          <CustomTextField
                            name="origem_agua"
                            value={obj_anexo?.origem_agua === undefined ? '' : obj_anexo?.origem_agua}
                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                      <TableCell
                        colSpan={4}
                        sx={{
                          fontWeight: 600,

                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Método de rega:
                          <CustomTextField
                            name="metodo_rega"
                            value={obj_anexo?.metodo_rega === undefined ? '' : obj_anexo?.metodo_rega}

                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        sx={{
                          fontWeight: 600,

                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Eficiência de rega:
                          <CustomTextField
                            name="eficiencia"
                            value={obj_anexo?.eficiencia === undefined ? '' : obj_anexo?.eficiencia}
                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                      <TableCell
                        colSpan={9}
                        sx={{
                          fontWeight: 600,

                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Razão de adsorção de sódio ajustada:
                          <CustomTextField
                            name="razao"
                            multiline
                            value={obj_anexo?.razao === undefined ? '' : obj_anexo?.razao}
                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead sx={{ minWidth: 100 }} colSpan={2}>
                        Elemento/nutriente
                        <BasicPopover text="Todos os campos deste quadro são de preenchimento obrigatório." />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        N
                        <BasicPopover text="Azoto sob a forma de nitrato (NO3)" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        P2O5
                        <BasicPopover text="Fósforo" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        K
                        <BasicPopover text="Potássio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Mg
                        <BasicPopover text="Magnésio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Bicarbonatos
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        B
                        <BasicPopover text="Boro" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Ca
                        <BasicPopover text="Cálcio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Clorestos
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Na
                        <BasicPopover text="Sódio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        pH(H2O)
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        C.E. (dS/m)
                        <BasicPopover text="Condutividade elétrica" />
                      </StyledTableHead>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        Resultado das análises
                      </StyledTableHead>
                      <StyledTableHead>(mg/l)</StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp1"
                          value={obj_anexo?.resultado_camp1 === undefined ? '' : obj_anexo?.resultado_camp1.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp1}
                          helperText={error_resultado_camp1 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp2"
                          value={obj_anexo?.resultado_camp2 === undefined ? '' : obj_anexo?.resultado_camp2.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp2}
                          helperText={error_resultado_camp2 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp3"
                          value={obj_anexo?.resultado_camp3 === undefined ? '' : obj_anexo?.resultado_camp3.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp3}
                          helperText={error_resultado_camp3 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp4"
                          value={obj_anexo?.resultado_camp4 === undefined ? '' : obj_anexo?.resultado_camp4.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp4}
                          helperText={error_resultado_camp4 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp5"
                          value={obj_anexo?.resultado_camp5 === undefined ? '' : obj_anexo?.resultado_camp5.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp5}
                          helperText={error_resultado_camp5 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp6"
                          value={obj_anexo?.resultado_camp6 === undefined ? '' : obj_anexo?.resultado_camp6.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp6}
                          helperText={error_resultado_camp6 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp7"
                          value={obj_anexo?.resultado_camp7 === undefined ? '' : obj_anexo?.resultado_camp7.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp7}
                          helperText={error_resultado_camp7 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp8"
                          value={obj_anexo?.resultado_camp8 === undefined ? '' : obj_anexo?.resultado_camp8.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp8}
                          helperText={error_resultado_camp8 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp9"
                          value={obj_anexo?.resultado_camp9 === undefined ? '' : obj_anexo?.resultado_camp9.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp9}
                          helperText={error_resultado_camp9 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp10"
                          value={obj_anexo?.resultado_camp10 === undefined ? '' : obj_anexo?.resultado_camp10.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp10}
                          helperText={error_resultado_camp10 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                      <StyledTableHead>
                        <CustomTextField
                          name="resultado_camp11"
                          value={obj_anexo?.resultado_camp10 === undefined ? '' : obj_anexo?.resultado_camp10.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_resultado_camp10}
                          helperText={error_resultado_camp10 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableHead>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead colSpan={2}>
                        Quantidade de nutriente fornecida pela água de rega
                        (kg/ha)
                      </StyledTableHead>
                      <StyledTableCell>
                        <CustomTextField
                          name="quantidade_nutri_camp1"
                          value={obj_anexo?.quantidade_nutri_camp1 === undefined ? '' : obj_anexo?.quantidade_nutri_camp1.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_quantidade_nutri_camp1}
                          helperText={error_quantidade_nutri_camp1 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTextField
                          name="quantidade_nutri_camp2"
                          value={obj_anexo?.quantidade_nutri_camp2 === undefined ? '' : obj_anexo?.quantidade_nutri_camp2.toString().replace('.', ',')}
                          onChange={onInputChange}
                          error={error_quantidade_nutri_camp2}
                          helperText={error_quantidade_nutri_camp2 ? "Apenas números são aceites" : ""}
                        />
                      </StyledTableCell>
                      <StyledTableCell
                        colSpan={9}
                        sx={{ backgroundColor: "lightgray" }}
                      ></StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={5}>
                        Identificar se a avaliação do teor de potássio na
                        água de rega foi expresso em:
                      </TableCell>
                      <TableCell colSpan={4}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <FormControlLabel
                            name="k"
                            label={
                              <Typography
                                fontFamily="candara"
                                fontSize={18}
                              >
                                K
                              </Typography>
                            }
                            aria-readonly
                            control={
                              <Checkbox
                                checked={!!obj_anexo?.k}
                                onChange={onInputChange}
                                name="k"
                                disabled={!flag_editar}
                                sx={{
                                  color: "#aaaaaa",
                                  "&.Mui-checked": {
                                    color: "#C94F1E",
                                  },
                                }}
                              />
                            }
                          />
                        </Stack>
                      </TableCell>
                      <TableCell colSpan={4}>
                        <FormControlLabel
                          name="ko"
                          label={
                            <Typography fontFamily="candara" fontSize={18}>
                              K2O
                            </Typography>
                          }
                          aria-readonly
                          control={
                            <Checkbox
                              checked={!!obj_anexo?.ko}
                              onChange={onInputChange}
                              name="ko"
                              disabled={!flag_editar}
                              sx={{
                                color: "#aaaaaa",
                                "&.Mui-checked": {
                                  color: "#C94F1E",
                                },
                              }}
                            />
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={4}
                        sx={{
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Data da colheita da água:
                          <TextField
                            variant="filled"
                            name="data_colheita"
                            error={error_data_colheira}
                            helperText={error_data_colheira === true ? "Preencha este campo" : ''}
                            type="date"

                            value={
                              obj_anexo?.data_colheita ? obj_anexo?.data_colheita : ""
                            }
                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Data emissão resultados:
                          <TextField
                            variant="filled"
                            name="data_resultados"
                            error={error_data_resultados}
                            helperText={error_data_resultados === true ? "Preencha este campo" : ''}
                            type="date"

                            value={
                              obj_anexo?.data_resultados ? obj_anexo?.data_resultados : ""
                            }
                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Nº de amostras:
                          <CustomTextField
                            name="n_amostras"
                            value={obj_anexo?.n_amostras === undefined ? '' : obj_anexo?.n_amostras}
                            onChange={onInputChange}
                            error={error_n_amostras}
                            helperText={error_n_amostras ? 'Apenas números são aceites' : ""}
                          />
                        </Stack>
                      </TableCell>
                      <TableCell
                        colSpan={3}
                        sx={{
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        <Stack
                          direction="row"
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          Nº do Boletim:
                          <CustomTextField
                            name="n_boletin"
                            value={obj_anexo?.n_boletin === undefined ? '' : obj_anexo?.n_boletin}
                            onChange={onInputChange}
                          />
                        </Stack>
                      </TableCell>
                    </TableRow>
                  </>
                )
              } else {
                return (
                  <>
                    <TableRow key={key}>
                      <TableCell colSpan={13}>
                        <Stack direction='row' sx={{ justifyContent: 'right' }}>
                          {is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoEditar
                              aoClicarEditar={() => {
                                set_obj_anexo(row)
                                set_flag_editar(true)
                                set_error_data_colheira(false)
                                set_error_data_resultados(false)

                              }}
                              mostrarBotaoApagar
                              aoClicarApagar={() => {
                                set_obj_anexo(row)
                                set_flag_editar(false)
                                set_open_dialog_tem_a_certeza_que_quer_eliminar(true)
                              }}
                            />}
                        </Stack>
                      </TableCell>

                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Dotação (m3/ha):
                      </TableCell>
                      <TableCell>{row.dotacao.toString().replace('.', ',')}</TableCell>

                      <TableCell
                        colSpan={2}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Origem da água:
                      </TableCell>
                      <TableCell colSpan={2}>
                        {row.origem_agua}
                      </TableCell>

                      <TableCell
                        colSpan={2}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Método de rega:
                      </TableCell>
                      <TableCell colSpan={4} sx={{}}>
                        {row.metodo_rega}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Eficiência de rega:
                      </TableCell>
                      <TableCell colSpan={3} sx={{}}>
                        {row.eficiencia}
                      </TableCell>

                      <TableCell
                        colSpan={4}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Razão de adsorção de sódio ajustada:
                      </TableCell>
                      <TableCell colSpan={4} sx={{}}>
                        {row.razao}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead sx={{ minWidth: 100 }} colSpan={2}>
                        Elemento/nutriente
                        <BasicPopover text="Todos os campos deste quadro são de preenchimento obrigatório." />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        N
                        <BasicPopover text="Azoto sob a forma de nitrato (NO3)" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        P2O5
                        <BasicPopover text="Fósforo" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        K
                        <BasicPopover text="Potássio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Mg
                        <BasicPopover text="Magnésio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Bicarbonatos
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        B
                        <BasicPopover text="Boro" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Ca
                        <BasicPopover text="Cálcio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Clorestos
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        Na
                        <BasicPopover text="Sódio" />
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        pH(H2O)
                      </StyledTableHead>
                      <StyledTableHead sx={{ minWidth: 100 }}>
                        C.E. (dS/m)
                        <BasicPopover text="Condutividade elétrica" />
                      </StyledTableHead>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead>
                        Resultado das análises
                      </StyledTableHead>
                      <StyledTableHead>(mg/l)</StyledTableHead>
                      <StyledTableCell>
                        {row.resultado_camp1.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp2.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp3.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp4.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp5.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp6.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp7.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp8.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp9.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp10.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.resultado_camp11.toString().replace('.', ',')}
                      </StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableHead colSpan={2}>
                        Quantidade de nutriente fornecida pela água de
                        rega (kg/ha)
                      </StyledTableHead>
                      <StyledTableCell>
                        {row.quantidade_nutri_camp1.toString().replace('.', ',')}
                      </StyledTableCell>
                      <StyledTableCell>
                        {row.quantidade_nutri_camp2.toString().replace('.', ',')}
                      </StyledTableCell>

                      <StyledTableCell
                        colSpan={9}
                        sx={{ backgroundColor: "lightgray" }}
                      ></StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={5}>
                        Identificar se a avaliação do teor de potássio na
                        água de rega foi expresso em:
                      </TableCell>

                      <TableCell colSpan={4}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          justifyContent="center"
                        >
                          <FormControlLabel
                            name="k"
                            label={
                              <Typography
                                fontFamily="candara"
                                fontSize={18}
                              >
                                K
                              </Typography>
                            }
                            aria-readonly
                            control={
                              <Checkbox
                                checked={!!row?.k}
                                onChange={onInputChange}
                                name="k"
                                disabled={!flag_editar}
                                sx={{
                                  color: "#aaaaaa",
                                  "&.Mui-checked": {
                                    color: "#C94F1E",
                                  },
                                }}
                              />
                            }
                          />
                        </Stack>
                      </TableCell>

                      <TableCell colSpan={4}>
                        <FormControlLabel
                          name="ko"
                          label={
                            <Typography
                              fontFamily="candara"
                              fontSize={18}
                            >
                              K2O
                            </Typography>
                          }
                          aria-readonly
                          control={
                            <Checkbox
                              checked={!!row?.ko}
                              onChange={onInputChange}
                              name="ko"
                              disabled={!flag_editar}
                              sx={{
                                color: "#aaaaaa",
                                "&.Mui-checked": {
                                  color: "#C94F1E",
                                },
                              }}
                            />
                          }
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Data da colheita da água:
                      </TableCell>
                      <TableCell colSpan={2}>
                        {row.data_colheita}
                      </TableCell>
                      <TableCell
                        colSpan={2}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Data emissão resultados:
                      </TableCell>
                      <TableCell colSpan={2}>
                        {row.data_resultados}
                      </TableCell>
                      <TableCell
                        colSpan={2}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Nº de amostras:
                      </TableCell>
                      <TableCell>{row.n_amostras}</TableCell>
                      <TableCell
                        colSpan={2}
                        sx={{
                          textAlign: "right",
                          fontWeight: 600,
                          fontFamily: "candara",
                        }}
                      >
                        Nº do Boletim:
                      </TableCell>
                      <TableCell>{row.n_boletin}</TableCell>
                    </TableRow>
                  </>
                )
              }
            })}
          </TableBody>
        </table>
        <ConfirmDialog
          open={open_dialog_tem_a_certeza_que_quer_eliminar}
          onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
          onConfirm={handle_delete_anexo}
          message="Deseja eliminar o registo?"
        />
        <ConfirmDialog
          open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
          onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
          onConfirm={() => handleCloseDialog()}
          message={mensagem_tem_a_certeza_de_apagar_alteracoes}
        />
      </TableContainer >
    </>
  );
};